import { useState, useEffect } from "react";
import { trackEvent } from "../../../../../utils/mixpanel";
import { createDummyData } from "../../../../../services/api-clinic";

/**
 * Manages dummy data mode toggle and auto-creation
 */
export const useDummyDataMode = (
  session: any,
  setLoading: (loading: boolean) => void,
) => {
  const [hasAttemptedDummyDataCreation, setHasAttemptedDummyDataCreation] =
    useState(false);
  const [useDummyData, setUseDummyData] = useState(false);

  // Toggle dummy data mode
  const toggleDummyData = () => {
    const newValue = !useDummyData;
    setUseDummyData(newValue);

    trackEvent(
      "Dummy Data Toggle Clicked",
      {
        previousValue: useDummyData,
        newValue: newValue,
      },
      session,
    );
  };

  const enableDummyDataForTesting = () => {
    if (useDummyData) {
      return;
    }

    setUseDummyData(true);
    trackEvent(
      "Dummy Data Testing Enabled",
      {
        source: "empty-state-button",
      },
      session,
    );
  };

  // Auto-create dummy data if needed
  const createDummyDataIfNeeded = async (
    scheduleData: any[],
    isLoading: boolean,
    totalAppointments: number,
  ) => {
    const shouldCreate =
      useDummyData &&
      !isLoading &&
      scheduleData?.length === 0 &&
      !hasAttemptedDummyDataCreation;

    if (shouldCreate && session?.clinicId) {
      console.log(
        "🧪 No dummy data found — auto-creating dummy patients and appointments...",
      );

      try {
        setLoading(true);
        await createDummyData(session, session.clinicId, {
          create_patients: true,
          create_appointments: true,
        });

        console.log("✅ Dummy patients and appointments created");
        setHasAttemptedDummyDataCreation(true);
        return true;
      } catch (error) {
        console.error("❌ Error auto-creating dummy data:", error);
        return false;
      } finally {
        setLoading(false);
      }
    }

    return false;
  };

  return {
    useDummyData,
    setUseDummyData,
    toggleDummyData,
    enableDummyDataForTesting,
    hasAttemptedDummyDataCreation,
    setHasAttemptedDummyDataCreation,
    createDummyDataIfNeeded,
  };
};
